import { Button, Column, Title } from 'rbx';
import * as React from 'react';

interface IProps {
    children?: React.ReactNode;
    buttons?: any;
}

export default class PageHeader extends React.Component<IProps, any> {
    private renderActionButtons = () => {
        const { buttons } = this.props;
        return (
            buttons && (
                <div className="column is-narrow">
                    <Button.Group>{buttons}</Button.Group>
                </div>
            )
        );
    };

    public render() {
        return (
            <div className="page-header">
                <div className="columns is-marginless">
                    <div className="column">
                        <Title size={5}>{this.props.children}</Title>
                    </div>
                    {this.renderActionButtons()}
                </div>
            </div>
        );
    }
}
